import custom_api_func from "./axios_api_func"; 
import {getCookie,getCsrfToken} from './get_csrfToken'

const BASE = "api/advisor-console";

async function getCsrfHeaderValue() {
  await getCsrfToken();
  return getCookie("csrftoken");
}

export const advisorConsoleApi = {
  getConversations: (params = {}) =>
    custom_api_func.get(`${BASE}/conversations/`, { params }),

  getMessages: (conversationId, sinceId = 0) =>
    custom_api_func.get(`${BASE}/conversations/${conversationId}/messages/`, {
      params: { since: sinceId },
    }),

  sendMessage: async (conversationId, body) => {
    const csrftoken = await getCsrfHeaderValue();
    return custom_api_func.post(
      `${BASE}/conversations/${conversationId}/messages/`,
      { body },
      { headers: { "X-CSRFToken": csrftoken } }
    );
  },

  markSeen: async (conversationId, lastMessageId) => {
    const csrftoken = await getCsrfHeaderValue();
    return custom_api_func.post(
      `${BASE}/conversations/${conversationId}/mark-seen/`,
      { last_message_id: lastMessageId },
      { headers: { "X-CSRFToken": csrftoken } }
    );
  },
};

export default advisorConsoleApi;